import { HTTPContentType, HTTPMethod } from 'utils/HTTPUtils';
import { routes } from '../constants/api';
import { apiFetch } from '../utils/apiClient';

type AccountStatus =
  { type: 'existingUser' } | { type: 'newUser'; requiresRegistration: true };

type AuthOptionsResponse = {
  accountStatus: AccountStatus;
};

export const getAuthOptions = async (
  email: string,
): Promise<AuthOptionsResponse> => {
  const body = {
    email,
  };

  const headers = new Headers({
    'Content-Type': HTTPContentType.JSON,
  });

  return apiFetch<AuthOptionsResponse>(routes.auth.options, {
    method: HTTPMethod.POST,
    body: JSON.stringify(body),
    headers,
  });
};

type SendOtpParams = {
  destination: string;
  metadata?: { name: string; locale: string };
};

type VerifyOtpParams = {
  email: string;
  code: string;
};

type VerifyOtpResponse = {
  token: string;
};

export const sendOtp = async ({
  destination,
  metadata,
}: SendOtpParams): Promise<void> => {
  const headers = new Headers({ 'Content-Type': HTTPContentType.JSON });
  return apiFetch(routes.auth.otp.send, {
    method: HTTPMethod.POST,
    body: JSON.stringify({
      method: 'email',
      destination,
      ...(metadata ? { metadata } : {}),
    }),
    headers,
  });
};

export const verifyOtp = async (
  params: VerifyOtpParams,
): Promise<VerifyOtpResponse> => {
  const headers = new Headers({ 'Content-Type': HTTPContentType.JSON });
  return apiFetch<VerifyOtpResponse>(routes.auth.otp.verify, {
    method: HTTPMethod.POST,
    body: JSON.stringify(params),
    headers,
  });
};
